import React from 'react';

export default function KontrakPerusahaan() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Kontrak Perusahaan Jepang</h1>
      <p className="text-gray-500">Halaman Kontrak Perusahaan Jepang</p>
    </div>
  );
}
